import { ShopifyAppNames } from "@redotech/redo-model/sales-channels";
import type { infer as zInfer } from "zod/v4";
import { array, boolean, object, string, enum as zEnum } from "zod/v4";

export const cloudXUPCType = ["sku", "barcode"] as const;
export type CloudXUPCType = (typeof cloudXUPCType)[number];

export const getCloudXIntegration = {
  name: "getCloudXIntegration" as const,
  input: object({}),
  output: object({
    cloudXIntegration: object({
      clientSecret: string(),
      warehouseAsPlainString: string(),
      testMode: boolean(),
      autoProcessReturns: boolean(),
      upcType: string(),
      excludedAppNames: array(zEnum(ShopifyAppNames)),
    }).optional(),
  }),
};

export type CloudXIntegration = zInfer<typeof getCloudXIntegration.output>;
